export enum OperatorType {
    Contains,
    Equals,
    DifferentThan,
    LessThan,
    MoreThan,
    LessThanOrEqual,
    MoreThanOrEqual,
    DoesNotContain,
    Empty,
    NotEmpty,
    In,
    NotIn,
}
